import React from "react";
// import { useNavigate } from "react-router-dom";
import MainHeading from "@/components/common/MainHeading";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { RefreshCw, AlertTriangle, CheckCircle2 } from "lucide-react";
// import { RoutesLink } from "@/utility/RouteLinks";

interface SalaryPreviewHeaderProps {
  formattedPeriod: string;
  allUsersCount: number;
  errorsCount: number;
  isLoading: boolean;
  isSubmitting: boolean;
  onRefresh: () => void;
  onCreateSalary: () => void;
}

export const SalaryPreviewHeader: React.FC<SalaryPreviewHeaderProps> = ({
  formattedPeriod,
  allUsersCount,
  errorsCount,
  isLoading,
  isSubmitting,
  onRefresh,
  onCreateSalary,
}) => {
  // const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 flex-wrap">
      {/* Left: Back + Title */}
      <div className="flex items-center gap-3">
        {/* <Button
          variant="outline"
          size="sm"
          className="bg-white hover:bg-slate-100 text-slate-700"
          onClick={() => navigate(RoutesLink.monthlyTeamAttendance)}
        >
          <ArrowLeft className="w-4 h-4 mr-1.5" />
          Back
        </Button> */}
        <div>
          <MainHeading title="Monthly Salary Preview" isBackButtonVisible={true} />
          <p className="text-xs text-slate-500 mt-0.5 pl-15">
            Period:{" "}
            <span className="font-semibold text-slate-700">
              {formattedPeriod}
            </span>
          </p>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          className="bg-white"
          onClick={onRefresh}
          disabled={isLoading}
        >
          <RefreshCw
            className={`w-3.5 h-3.5 mr-1.5 ${isLoading ? "animate-spin" : ""}`}
          />
          Refresh Preview
        </Button>

        <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-100 rounded-full px-3 py-1 text-xs">
          {allUsersCount} Employees Loaded
        </Badge>

        {errorsCount > 0 && (
          <Badge className="bg-amber-100 text-amber-900 hover:bg-amber-100 rounded-full px-3 py-1 text-xs flex items-center gap-1">
            <AlertTriangle className="w-3.5 h-3.5 text-amber-600" />
            {errorsCount} Failures
          </Badge>
        )}

        <Button
          type="button"
          size="sm"
          onClick={onCreateSalary}
          disabled={isSubmitting || isLoading || allUsersCount === 0}
          className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-lg gap-1.5 px-4 shadow-sm"
        >
          {isSubmitting ? (
            <RefreshCw className="w-3.5 h-3.5 animate-spin" />
          ) : (
            <CheckCircle2 className="w-4 h-4" />
          )}
          {isSubmitting ? "Creating Salary..." : "Create Salary"}
        </Button>
      </div>
    </div>
  );
};
